import api from "./axios";
import { OrgNode, UpdateOrgEmployeeRequest, EntraSyncResult } from "../interfaces/Organograma";

const BASE = "/Org";

export async function syncOrg(): Promise<EntraSyncResult> {
  const { data } = await api.post(`${BASE}/sync`);
  return data;
}

export async function getOrgTree(): Promise<OrgNode[]> {
  const { data } = await api.get(`${BASE}/tree`);
  return Array.isArray(data) ? data : [];
}

export async function updateOrgEmployee(
  id: number,
  req: UpdateOrgEmployeeRequest
): Promise<OrgNode> {
  const { data } = await api.put(`${BASE}/employee/${id}`, req);
  return data;
}
